import { Icon as Icons, Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-height: 156px;
  padding: 10px;
  width: 100%;
  background-color: ${colors.white};
  border: 1px solid ${colors.blue};
  border-radius: 8px;
`
export const TitleCard = styled.span`
  color: ${colors.green};
  font-size: 14px;
  font-weight: 700;
  font-style: italic;
`

export const OcInfoCard = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 122px;
  padding: 5px;
  background-color: ${colors.gray5};
  color: ${colors.black};
  border-radius: 4px;
  font-style: italic;
  font-weight: bold;
  font-size: 14px;
  cursor: not-allowed;
  opacity: 0.6;
`
export const Title = styled.span`
  color: ${colors.blue};
  font-size: 14px;
`
export const Subtitle = styled.span`
  color: ${colors.grayDark};
  font-size: 14px;
  font-weight: 700;
`
export const Icon = styled(Icons)`
  color: ${colors.blue};
  display: flex;
  align-items: center;
`

export const CardContainer = styled.div`
  display: flex;
  min-height: 156px;
  padding: 10px;
  width: 100%;
  background-color: ${colors.white};
  border: 1px solid ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%), 0 2px 6px rgb(0 0 0 / 23%);
`

export const GridContainer = styled(Grid)`
  padding: 5px 0;
`
export const IconProduto = styled.img`
  src: ${props => props.src};
  color: ${colors.blue};
  width: 16px;
  height: 16px;
  margin-right: 5px;
`
